import React from "react";

const Link3 = () => {
  return <div className="link-3">Link 3</div>;
};

export default Link3;
